const columnLabels = [
  { key: "name", label: "Permission Name" },
  { key: "method", label: "Method" },
  { key: "endpoint", label: "Navigation Endpoint" },
  { key: "navItemSlugs", label: "Navigation Items" },
  { key: "description", label: "Description" },
  { key: "isActive", label: "Status" }
];

export const COLUMNS = columnLabels.map(({ key, label }) => ({
  Header: label,
  Footer: label,
  accessor: key
}));
